// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"40bf5a6f","39":"f2cadf42","243":"299df407","462":"ada64f80","562":"47f0473b","683":"661cb3f0"}[chunkId] + ".chunk.css";
};